import jsx from '../jsx';
import { setSplit, runSandbox, saveUrl, reset } from './sandbox-utils';
import { alertElement, enableJSCheckbox } from './element-selectors';

const viewOptions = [50, 100, 0];
let currentViewOption = 0;

export const initSandboxNav = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const nav = document.getElementById('nav');
    if (nav) {
      nav.prepend(
        <button
          onclick={() => {
            enableJSCheckbox.checked = true;
            alertElement?.animate(
              { opacity: 0 },
              { duration: 250, fill: 'forwards' },
            );
            runSandbox();
          }}
        >
          Run Project
        </button>,
        <button
          onclick={() => {
            currentViewOption += 1;
            setSplit(viewOptions[currentViewOption % viewOptions.length]);
          }}
        >
          Cycle View
        </button>,
        <button onclick={() => saveUrl()}>Save URL</button>,
        <button onclick={() => reset()}>Reset Project</button>,
      );
    }
  });
};
